const ANIMATION_DURATION_MS = 250;
const CLOSE_MODAL_MESSAGE = 'common-ui:modal.close';

export { ANIMATION_DURATION_MS, CLOSE_MODAL_MESSAGE };
